export const weekdays = [
  {
    day: '周一',
    items: [
      { time: '19:00', title: '海风邮局的来信', note: '日常 / 治愈 · 第 05 话' },
      { time: '22:30', title: '银匙占卜屋', note: '奇幻 / 单元剧 · 第 03 话' },
    ],
  },
  {
    day: '周二',
    items: [
      { time: '20:00', title: '春分立食屋', note: '日常 / 美食 · 第 06 话' },
      { time: '24:00', title: '幻夜书房奇谭', note: '奇幻 / 悬疑 · 第 04 话' },
    ],
  },
  {
    day: '周三',
    items: [
      { time: '21:00', title: '玻璃工坊的少年', note: '青春 / 成长 · 第 07 话' },
      { time: '24:10', title: '黄昏列车终点站', note: '深夜档 / 悬疑 · 第 09 话' },
    ],
  },
  {
    day: '周四',
    items: [
      { time: '19:30', title: '云端杂货铺', note: '日常 / 奇幻 · 第 08 话' },
      { time: '22:30', title: '星屑彼端的旅人', note: '奇幻 / 冒险 · 第 08 话' },
    ],
  },
  {
    day: '周五',
    items: [
      { time: '20:30', title: '纸鸢侦探事务所', note: '悬疑 / 推理 · 第 05 话' },
      { time: '23:00', title: '雾之都侦探社', note: '悬疑 / 奇幻 · 第 06 话' },
    ],
  },
  {
    day: '周六',
    items: [
      { time: '19:30', title: '妖精庭院物语', note: '奇幻 / 治愈 · 第 05 话' },
      { time: '21:00', title: '夏夜祭的巡礼', note: '校园 / 恋爱 · 第 04 话' },
    ],
  },
  {
    day: '周日',
    items: [
      { time: '20:00', title: '机械心脏与春日约定', note: '科幻 / 治愈 · 第 07 话' },
      { time: '22:00', title: '灯塔与鲸歌', note: '奇幻 / 音乐 · 第 06 话' },
    ],
  },
];